import httpClient from "@/services/httpClient";
import {
    server, trademark_const
} from "@/services/constants";

export const getAlltmupdatestatus = () => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.TMUPDATESTATUS + `/getAll`);
};

export const gettmupdatestatusById = (id) => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.TMUPDATESTATUS + `/getBytmupdatestatus_id/${id}`);
};

export const createtmupdatestatus = (data) => {
    return httpClient.post(`${trademark_const.trademark_url}/` + server.TMUPDATESTATUS, data);
};

export const updatetmupdatestatus = (id, data) => {
    return httpClient.put(`${trademark_const.trademark_url}/` + server.TMUPDATESTATUS + `/${id}`, data);
};


export const deletetmupdatestatus = (id) => {
    return httpClient.delete(`${trademark_const.trademark_url}/` + server.TMUPDATESTATUS + `/${id}`);
};